import beepAudio from '../mp3/beep.mp3';
import ring1Audio from '../mp3/ring_1.mp3';
import ring2Audio from '../mp3/ring_2.mp3';

export const SOUND_FILES = {
    'beep.mp3': beepAudio,
    'ring_1.mp3': ring1Audio,
    'ring_2.mp3': ring2Audio,
};

export const AVAILABLE_SOUNDS = [
    { id: 'ring_1.mp3', name: 'Timbre 1 (Campana Restaurante)' },
    { id: 'ring_2.mp3', name: 'Timbre 2 (Doble Ring)' },
    { id: 'beep.mp3', name: 'Beep Corto (Alerta)' },
];

/**
 * Reproduce un sonido del catálogo de MP3 disponibles.
 * @param {string} soundKey - 'ring_1.mp3', 'ring_2.mp3', o 'beep.mp3'
 */
export const playSound = (soundKey) => {
    try {
        const audioSrc = SOUND_FILES[soundKey] || SOUND_FILES['ring_1.mp3'];
        if (audioSrc) {
            const audio = new Audio(audioSrc);
            audio.volume = 1.0;
            const playPromise = audio.play();
            if (playPromise !== undefined) {
                playPromise.catch((error) => {
                    // Los navegadores requieren interacción previa del usuario para reproducir audio automáticamente
                    console.warn('El navegador bloqueó la reproducción automática de audio:', error);
                });
            }
        }
    } catch (e) {
        console.error('Error al reproducir sonido:', e);
    }
};

export default playSound;
